import { FormHelperText } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledFormHelperText = styled(FormHelperText)(({ theme }) => ({
  marginLeft: '0px',
  marginTop: '8px',
  fontSize: '12px',
  lineHeight: '100%',
  color: theme.palette.custom.black[30],
}));
